// extracted by mini-css-extract-plugin
export var checkbox = "_7i-0";
export var circle = "_7i-3";
export var horizontalContainer = "_7i-7";
export var sm = "_7i-5";
export var switch0 = "_7i-2";
export var switchDisabled = "_7i-8";
export var switchEnabled = "_7i-1";
export var textSwitchContainer = "_7i-9";
export var textSwitchOption = "_7i-a";
export var textSwitchOptionSelected = "_7i-b";
export var verticalContainer = "_7i-6";
export var xs = "_7i-4";